import React, {Component} from 'react';
import FocusPageId from "../../FocusPageId";
import {Link} from "react-router-dom";

let i=0;
class CustomsRequirements extends React.Component {
    componentDidMount() {
        // window.scrollTo(0, 0);
        let element = document.getElementById(FocusPageId.selectedId.elementId);
        element.scrollIntoView(true);
        element.classList.add('mystyle');
        // element.style.paddingTop="50px"
        window.scrollTo({
            top: document.getElementById(FocusPageId.selectedId.elementId).offsetTop - 40,
            behavior: 'smooth'
        });

    }
    constructor(props) {
        super(props);

        this.positionAdject=this.positionAdject.bind()
    };

    positionAdject = () => {
        i++;
        // if(i<3){
        //     document.getElementById(FocusPageId.selectedId.elementId).style.paddingTop="0px";

        // }

    };
    render() {

        return (
            <div className="static-pages" onWheel={() => this.positionAdject()}>
                <div className="background-div">
                    <h3><b><li>輸入関税要件について</li></b></h3>
                     <div className="brElement"></div> <div className="brElement"></div>
                    <h4  id="a"><b> 輸入手続きが必要ですか？</b>
                    </h4>
                    <p className='all-content-font-size'>輸送費用・日本側通関費用・関税・消費税、すべて基板製造費用に含まれております。
                    </p>
                    <p className='all-content-font-size'> お客様に変わり弊社で申告と納税を行っております、煩わしい輸入手続きをお客様にて行う必要がありません、
                    </p>
                    <p>荷物が届くのを待つだけです。</p>
                    <div className='col-md-10'></div>
                    <div className='col-md-2 col-12-custom'>
                        <Link to="/customsrequirementsTopic">
                            <span className='font-size-20'>
                            戻る
                            </span>
                        </Link>
                    </div>

                </div>
            </div>
        );
    }
}

export default CustomsRequirements;




// WEBPACK FOOTER //
// ./src/components/Site/SiteRoot/Navigation/LinkPages/FaqPages/CustomsRequirements.js